import React from "react";

import { useState } from "react";

const INRInvestorsTable = ({ investors = [], onEdit, onDelete }) => {
  const [editIdx, setEditIdx] = useState(null);
  const [editData, setEditData] = useState({});

  const startEdit = (idx, inv) => {
    setEditIdx(idx);
    setEditData({ ...inv });
  };
  const cancelEdit = () => {
    setEditIdx(null);
    setEditData({});
  };
  const handleEditChange = (e) => {
    const { name, value } = e.target;
    const updatedData = { ...editData, [name]: value };

    // Auto-calculate balance when received or sent amounts change
    if (name === "received" || name === "sent") {
      const received = name === "received" ? value : editData.received;
      const sent = name === "sent" ? value : editData.sent;

      // Always calculate balance (even if one field is empty, treat as 0)
      const receivedNum = parseFloat(received) || 0;
      const sentNum = parseFloat(sent) || 0;
      // Store as number to preserve precision
      updatedData.balance = receivedNum - sentNum;
    }

    setEditData(updatedData);
  };
  const saveEdit = () => {
    if (onEdit) onEdit(editData);
    setEditIdx(null);
    setEditData({});
  };

  return (
    <div className="overflow-x-auto bg-white rounded-lg shadow-md">
      <table className="min-w-full divide-y divide-gray-200">
        <thead className="bg-gradient-to-r from-gray-50 to-gray-100">
          <tr>
            <th className="px-4 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">
              Date
            </th>
            <th className="px-4 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">
              Name
            </th>
            <th className="px-4 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">
              Phone Number
            </th>
            <th className="px-4 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">
              Received
            </th>
            <th className="px-4 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">
              Sent
            </th>
            <th className="px-4 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">
              Balance
            </th>
            <th className="px-4 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">
              Remarks
            </th>
            <th className="px-4 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">
              Added By
            </th>
            <th className="px-4 py-4 text-center text-xs font-semibold text-gray-700 uppercase tracking-wider">
              Actions
            </th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          {investors.length === 0 ? (
            <tr>
              <td colSpan="9" className="px-4 py-8 text-center text-gray-500">
                <div className="flex flex-col items-center space-y-2">
                  <svg
                    className="w-12 h-12 text-gray-400"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197m13.5-9a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z"
                    />
                  </svg>
                  <p className="text-lg font-medium">No INR investors found</p>
                  <p className="text-sm">
                    Add your first INR investor to get started.
                  </p>
                </div>
              </td>
            </tr>
          ) : (
            investors.map((inv, idx) => (
              <tr key={inv.id || idx}>
                {editIdx === idx ? (
                  <>
                    <td className="px-4 py-3">
                      <input
                        type="date"
                        name="date"
                        value={editData.date || ""}
                        onChange={handleEditChange}
                        className="border border-gray-300 rounded-lg px-3 py-2 w-32 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                      />
                    </td>
                    <td className="px-4 py-3">
                      <input
                        type="text"
                        name="name"
                        value={editData.name || ""}
                        onChange={handleEditChange}
                        placeholder="Enter name"
                        className="border border-gray-300 rounded-lg px-3 py-2 w-36 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                      />
                    </td>
                    <td className="px-4 py-3">
                      <input
                        type="tel"
                        name="phone_number"
                        value={editData.phone_number || ""}
                        onChange={handleEditChange}
                        placeholder="Phone number"
                        className="border border-gray-300 rounded-lg px-3 py-2 w-32 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                      />
                    </td>
                    <td className="px-4 py-3">
                      <div className="relative">
                        <div className="absolute inset-y-0 left-0 flex items-center pl-2">
                          <span className="text-gray-500 text-sm">₹</span>
                        </div>
                        <input
                          type="number"
                          name="received"
                          value={editData.received || ""}
                          onChange={handleEditChange}
                          step="0.01"
                          placeholder="0.00"
                          className="border border-gray-300 rounded-lg pl-6 pr-3 py-2 w-28 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        />
                      </div>
                    </td>
                    <td className="px-4 py-3">
                      <div className="relative">
                        <div className="absolute inset-y-0 left-0 flex items-center pl-2">
                          <span className="text-gray-500 text-sm">₹</span>
                        </div>
                        <input
                          type="number"
                          name="sent"
                          value={editData.sent || ""}
                          onChange={handleEditChange}
                          step="0.01"
                          placeholder="0.00"
                          className="border border-gray-300 rounded-lg pl-6 pr-3 py-2 w-28 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        />
                      </div>
                    </td>
                    <td className="px-4 py-3">
                      <div className="relative">
                        <input
                          type="text"
                          name="balance"
                          value={
                            editData.balance
                              ? parseFloat(editData.balance).toLocaleString(
                                  "en-IN",
                                  {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  }
                                )
                              : "0.00"
                          }
                          readOnly
                          className={`border border-gray-300 rounded-lg px-3 py-2 w-28 bg-gray-50 cursor-not-allowed ${
                            editData.balance
                              ? parseFloat(editData.balance) >= 0
                                ? "text-green-700 font-semibold"
                                : "text-red-700 font-semibold"
                              : "text-gray-700"
                          }`}
                          title="Auto-calculated: Received - Sent"
                        />
                        <div className="absolute inset-y-0 right-0 flex items-center pr-2">
                          <svg
                            className="w-3 h-3 text-gray-400"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 14h.01M12 11h.01M9 11h.01M15 11h.01M10 6V4a2 2 0 012-2h0c1.1 0 2 .9 2 2v2"
                            />
                          </svg>
                        </div>
                      </div>
                    </td>
                    <td className="px-4 py-3">
                      <input
                        type="text"
                        name="remarks"
                        value={editData.remarks || ""}
                        onChange={handleEditChange}
                        placeholder="Remarks"
                        className="border border-gray-300 rounded-lg px-3 py-2 w-36 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                      />
                    </td>
                    <td className="px-4 py-3 text-gray-600">
                      {inv.added_by || inv.addedBy || "-"}
                    </td>
                    <td className="px-4 py-3">
                      <div className="flex justify-center gap-2">
                        <button
                          onClick={saveEdit}
                          className="flex items-center gap-1 bg-green-600 text-white px-3 py-2 rounded-lg hover:bg-green-700 transition-colors duration-200"
                        >
                          <svg
                            className="w-4 h-4"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M5 13l4 4L19 7"
                            />
                          </svg>
                          Save
                        </button>
                        <button
                          onClick={cancelEdit}
                          className="flex items-center gap-1 bg-gray-500 text-white px-3 py-2 rounded-lg hover:bg-gray-600 transition-colors duration-200"
                        >
                          <svg
                            className="w-4 h-4"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M6 18L18 6M6 6l12 12"
                            />
                          </svg>
                          Cancel
                        </button>
                      </div>
                    </td>
                  </>
                ) : (
                  <>
                    <td className="px-4 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                      {inv.date}
                    </td>
                    <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-900 font-semibold">
                      {inv.name}
                    </td>
                    <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-600">
                      {inv.phone_number || "-"}
                    </td>
                    <td className="px-4 py-4 whitespace-nowrap text-sm text-green-600 font-medium">
                      {inv.received !== null &&
                      inv.received !== undefined &&
                      inv.received !== ""
                        ? `₹${parseFloat(inv.received).toLocaleString("en-IN", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}`
                        : "₹0.00"}
                    </td>
                    <td className="px-4 py-4 whitespace-nowrap text-sm text-red-600 font-medium">
                      {inv.sent !== null &&
                      inv.sent !== undefined &&
                      inv.sent !== ""
                        ? `₹${parseFloat(inv.sent).toLocaleString("en-IN", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}`
                        : "₹0.00"}
                    </td>
                    <td
                      className={`px-4 py-4 whitespace-nowrap text-sm font-medium ${
                        inv.balance !== null &&
                        inv.balance !== undefined &&
                        inv.balance !== "" &&
                        parseFloat(inv.balance) < 0
                          ? "text-red-600"
                          : "text-blue-600"
                      }`}
                    >
                      {inv.balance !== null &&
                      inv.balance !== undefined &&
                      inv.balance !== ""
                        ? `₹${parseFloat(inv.balance).toLocaleString("en-IN", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}`
                        : "₹0.00"}
                    </td>
                    <td
                      className="px-4 py-4 text-sm text-gray-600 max-w-xs truncate"
                      title={inv.remarks}
                    >
                      {inv.remarks || "-"}
                    </td>
                    <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-500">
                      {inv.added_by || inv.addedBy || "-"}
                    </td>
                    <td className="px-4 py-4 whitespace-nowrap">
                      <div className="flex justify-center gap-2">
                        <button
                          onClick={() => startEdit(idx, inv)}
                          className="flex items-center gap-1 bg-blue-600 text-white px-3 py-2 rounded-lg hover:bg-blue-700 transition-colors duration-200 text-sm"
                          title="Edit record"
                        >
                          <svg
                            className="w-4 h-4"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                            />
                          </svg>
                          Edit
                        </button>
                        <button
                          onClick={() => onDelete && onDelete(inv)}
                          className="flex items-center gap-1 bg-red-600 text-white px-3 py-2 rounded-lg hover:bg-red-700 transition-colors duration-200 text-sm"
                          title="Delete record"
                        >
                          <svg
                            className="w-4 h-4"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                            />
                          </svg>
                          Delete
                        </button>
                      </div>
                    </td>
                  </>
                )}
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default INRInvestorsTable;
